import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import NewsTicker from './components/NewsTicker';
import Home from './pages/Home';
import Korlektioner from './pages/Korlektioner';
import Teorilektioner from './pages/Teorilektioner';
import Teoriprov from './pages/Teoriprov';
import Risk1 from './pages/Risk1';
import Risk2 from './pages/Risk2';
import Tips from './pages/Tips';
import TipsPost from './pages/TipsPost';
import OmOss from './pages/OmOss';
import Kontakt from './pages/Kontakt';
import NotFound from './pages/NotFound';

function Scroll() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <Scroll />
      <NewsTicker />
      <Header />
      <main>
        <Routes>
          <Route path="/"                 element={<Home />} />
          <Route path="/korlektioner"     element={<Korlektioner />} />
          <Route path="/teorilektioner"   element={<Teorilektioner />} />
          <Route path="/teoriprov"        element={<Teoriprov />} />
          <Route path="/riskutbildning-1" element={<Risk1 />} />
          <Route path="/riskutbildning-2" element={<Risk2 />} />
          <Route path="/tips"             element={<Tips />} />
          <Route path="/tips/:slug"       element={<TipsPost />} />
          <Route path="/om-oss"           element={<OmOss />} />
          <Route path="/kontakt"          element={<Kontakt />} />
          <Route path="*"                 element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}
